import { TreeIf } from '../interfaces/tree-if';
import { TermIf } from '../interfaces/term-if';

export class ReportingTermWrapper implements TreeIf {
  private uid: string;
  private schedulingTermUid: string;
  private reportingTermName: string;
  private startDate: Date;
  private endDate: Date;
  private parent?: ReportingTermWrapper;
  private children?: Array<ReportingTermWrapper>;

  constructor(term: TermIf, children?: Array<ReportingTermWrapper>) {
    this.uid = term.getUid();
    this.schedulingTermUid = term.getSchedulingTermUid();
    this.reportingTermName = term.getReportingTermName();
    this.startDate = term.getStartDate();
    this.endDate = term.getEndDate();
    this.children = children;
  }

  getUid(): string {
    return this.uid;
  }

  getReportingTermName(): string {
    return this.reportingTermName;
  }

  getName(): string {
    return this.reportingTermName;
  }

  getSchedulingTermUid(): string {
    return this.schedulingTermUid;
  }

  getStartDate(): Date {
    return this.startDate;
  }

  setStartDate(startDate: Date): void {
    this.startDate = startDate;
  }

  getEndDate(): Date {
    return this.endDate;
  }

  setEndDate(endDate: Date): void {
    this.endDate = endDate;
  }

  setParent(parent: ReportingTermWrapper): void {
    this.parent = parent;
    this.parent.addChild(this);
  }

  isRoot(): boolean {
    return this.parent == null;
  }

  addChild(child: ReportingTermWrapper): void {
    if (this.children == null) {
      this.children = [];
    }
    this.children.push(child);
  }

  getChildren(): Array<ReportingTermWrapper> | undefined {
    return this.children;
  }
}
